module.exports = __webpack_public_path__ + "media/images/about-left-image-7fc4aa6ad1c25408ee92d2a0b368a4e4.png";